<template>
  <!--コンテンツ-->
  <main class="renew3_top">
    <!--メインバナー-->
    <div class="mv">
      <div class="renew3_wrapper mv_wrapper">
        <router-link to="/eprinthelp" class="mv_link">
          <img
            src="/static/renew3_img/top20250124.png"
            alt="コンビニ印刷"
            class="mv_img"
          />
        </router-link>
      </div>
    </div>

    <div class="news" v-if="noticeInfo">
      <div data-v-450fc904 class="renew3_wrapper">
        <p class="news_text">
          お知らせ｜<a
            :href="noticeInfo.linkurl"
            target="_blank"
            v-if="noticeInfo.linktarget == '1'"
            class="news_link"
            >{{ noticeInfo.contexts }}</a
          ><a :href="noticeInfo.linkurl" v-else class="news_link">{{
            noticeInfo.contexts
          }}</a>
        </p>
      </div>
    </div>

    <!--学校名-->
    <div class="school-header">
      <h2 class="school-header__title">
        <span class="school-header__text">{{ schoolName }}</span>
        <span class="school-header__icon"></span>
      </h2>
    </div>

    <!--テンプレート選択-->
    <div class="format">
      <h3 class="section-title__group">
        <span class="section-title__en">TEMPLATE</span>
        <span class="section-title__jp">テンプレート一覧</span>
      </h3>

      <div class="renew3_wrapper format_wrapper">
        <!--テンプレートブロック-->
        <div id="rirekisyo-index" class="format_block format_block1">
          <!--<h3 class="format_block_h3"></h3>-->

          <div class="flex format_block_flex">
            <a
              href="/format/rirekisho_beauty"
              id="toplnk_rirekisho_job_change"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_job_change.png"
                  alt="専用履歴書"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3 format_link_h3big">専用履歴書</h3>
                <p class="format_link_txt">美容学校用にカスタマイズ</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/entrysheet"
              id="toplnk_entrysheet"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／1枚</p>
                <img
                  src="/static/img/formats/sample/entrysheet_img.png"
                  alt="エントリーシートテンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom">
                <h3 class="format_link_h3">エントリーシート</h3>
                <!--<p class="format_link_txt"></p>-->
              </div>
              <button class="pc format_btn">エントリーシートをつくる</button>
              <button class="sp format_btn">このESをつくる</button>
            </a>
            <a
              href="/format/letter"
              id="toplnk_rirekisho_job_change"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／1枚</p>
                <img
                  src="/static/img/formats/sample/yagish_letter_img.jpeg"
                  alt="送付状テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom">
                <h3 class="format_link_h3">送付状</h3>
                <!--<p class="format_link_txt"></p>-->
              </div>
              <button class="format_btn">この送付状をつくる</button>
            </a>
            <a
              v-if="$oemContext.isFormatAllowed('english_resume')"
              href="/format/english_resume"
              id="toplnk_english_resume"
              class="format_link"
            >
              <div class="format_link_top">
                <p class="format_link_memo">A4／1枚</p>
                <img
                  src="/static/img/formats/english_resume.png"
                  alt="英語の履歴書テンプレート"
                  class="format_link_img"
                />
              </div>
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">英語の履歴書</h3>
                <p class="format_link_txt">外資系・海外企業向け</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--ヤギッシュとは？-->
    <div class="renew3_wrapper about-content">
      <h3 class="section-title__group">
        <span class="section-title__en">ABOUT YAGISH</span>
        <span class="section-title__jp">ヤギッシュとは？</span>
      </h3>

      <p class="about-content__lead">
        yagish（ヤギッシュ）は、ブラウザ上で履歴書がつくれる無料サービスです。外出先でも、必要なときにいつでも履歴書を作成でき、作成した履歴書はダウンロードやコンビニ印刷も可能！※学校専用ヤギッシュのアカウントで、通常のヤギッシュもログイン可能です
      </p>

      <div class="about-grid">
        <article class="about-card">
          <div class="about-card__image-wrapper">
            <img
              src="/static/img/beauty/top/aboutimg01.png"
              alt="豊富なテンプレート"
              class="about-card__image"
            />
          </div>
          <h3 class="about-card__title">豊富なテンプレート</h3>
          <p class="about-card__text">
            スマホでサクッと作成可能、美容学校ならではのアピールができます
          </p>
        </article>

        <article class="about-card">
          <div class="about-card__image-wrapper">
            <img
              src="/static/img/beauty/top/aboutimg02.png"
              alt="履歴書をPDFで"
              class="about-card__image"
            />
          </div>
          <h3 class="about-card__title">履歴書をPDFで</h3>
          <p class="about-card__text">
            ダウンロード・メール送信でデータで管理もしくはコンビニ印刷で紙で保管
          </p>
        </article>

        <article class="about-card">
          <div class="about-card__image-wrapper">
            <img
              src="/static/img/beauty/top/aboutimg03.png"
              alt="ヤギのメール便"
              class="about-card__image"
            />
          </div>
          <h3 class="about-card__title">ヤギのメール便</h3>
          <p class="about-card__text">
            ダウンロードせず、サイト上で履歴書を送信することができます
          </p>
        </article>
      </div>
    </div>

    <!--キャリアセンター-->
    <div
      v-for="(banner, index) in supportBanners"
      :key="index"
      class="support-banner"
    >
      <a :href="banner.link" class="support-banner__link">
        <div class="support-banner__content">
          <div class="support-banner__image-container">
            <img
              :src="banner.image"
              :alt="banner.text.alt"
              class="support-banner__bg"
            />

            <div class="support-banner__overlay">
              <div class="support-banner__badge">
                <p class="support-banner__en">{{ banner.text.en }}</p>
                <p class="support-banner__jp">{{ banner.text.jp }}</p>
              </div>
            </div>
          </div>

          <div class="support-banner__arrow-circle">
            <span class="support-banner__arrow-icon"></span>
          </div>
        </div>
      </a>
    </div>

    <!--NEWS-->
    <div v-if="newsItems && newsItems.length" class="news-section">
      <div class="renew3_wrapper news-inner">
        <div class="news-header">
          <h2 class="news-title">NEWS</h2>
          <p class="news-subtitle">あなたにピッタリのお知らせ</p>
        </div>

        <div class="news-list">
          <div
            v-for="(item, index) in newsItems"
            :key="index"
            class="news-card"
          >
            <div class="news-card__image-wrapper">
              <img
                :src="item.image"
                :alt="item.title"
                class="news-card__image"
              />
            </div>

            <div class="news-card__content">
              <p class="news-card__text">{{ item.description }}</p>

              <div class="login-btn__button-area">
                <a :href="item.link" class="login-btn__btn"> くわしくみる </a>
                <img
                  src="/static/img/beauty/top/loginbtnbadge.png"
                  alt="ログイン限定"
                  class="login-btn__badge"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--専売品-->
    <div v-if="shopItems && shopItems.length" class="shop-carousel">
      <div class="ribbon-container">
        <span class="ribbon-badge">美容学生限定</span>
      </div>

      <h3 class="section-title__group">
        <span class="section-title__en">SHOP</span>
        <span class="section-title__jp">美容専売品購入</span>
      </h3>

      <div class="carousel-viewport">
        <div
          class="carousel-track"
          :style="{ transform: `translateX(-${currentIndex * 33.33}%)` }"
        >
          <div
            v-for="(item, index) in shopItems"
            :key="index"
            class="card-item"
          >
            <a :href="item.link" class="support-banner__link">
              <img :src="item.image" :alt="item.alt" class="card-image" />
            </a>
          </div>
        </div>
      </div>

      <div class="login-btn__button-area">
        <a href="" class="login-btn__btn"> SHOPで購入する </a>
        <img
          src="/static/img/beauty/top/loginbtnbadge.png"
          alt="ログイン限定"
          class="login-btn__badge"
        />
      </div>
    </div>
  </main>
</template>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

/*共通*/
.renew3_top .renew3_wrapper {
  width: 768px;
  margin: 0 auto;
  padding: 0 10px;
}

/*MV*/
.renew3_top .mv {
  margin-bottom: 20px;
}

.renew3_top .mv_img {
  width: 768px;
  max-width: 100%;
  margin-top: 0px;
}

//学校名
// 変数（プロジェクトの共通設定ファイルに置くのが理想的です）
$color-primary: #e95b10;
$font-family-serif: 'Yu Mincho', 'YuMincho', serif;

.school-header {
  display: flex;
  justify-content: center;
  padding: 0 0 20px;

  &__title {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0;
    // h2のデフォルトスタイルをリセット
    font-weight: normal;
  }

  &__text {
    color: $color-primary;
    font-family: $font-family-serif;
    font-size: 1.4rem;
    letter-spacing: 0.3em;
    line-height: 1.2;
    text-align: center;
  }

  &__icon {
    display: block;
    margin-top: 10px;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 16px solid #e95b10;
  }
}

.section-title {
  &__group {
    margin-bottom: 30px;
  }

  &__en {
    font-family: $font-family-serif;
    font-size: 1.4rem;
    color: #0f9934;
    text-align: center;
    line-height: 1;
    letter-spacing: 0.35em;
    // 字間（letter-spacing）による右側の余白を打ち消して真ん中に配置
    margin-right: -0.35em;
    display: block;
  }

  &__jp {
    font-size: 1rem;
    font-weight: normal;
    text-align: center;
    line-height: 1;
    letter-spacing: 0.1em;
    margin-top: 8px; // 英語との間隔
    display: block;
  }
}

/*テンプレート選択*/
.renew3_top .format {
  margin-bottom: 50px;
}

.renew3_top .format_block {
  margin-bottom: 30px;
}

.renew3_top .format_block_h3 {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.renew3_top .format_block_h3_2 {
  margin-bottom: 0;
}

.renew3_top .format_block_lead {
  font-size: 14px;
  margin-bottom: 20px;
}

.renew3_top .format_block_flex {
  justify-content: space-between;
  flex-wrap: wrap;
}

.renew3_top .format_link {
  width: calc(100% / 3 - 15px);
  margin-top: 20px;
}

.renew3_top .format_link:nth-of-type(1),
.renew3_top .format_link:nth-of-type(2),
.renew3_top .format_link:nth-of-type(3) {
  margin-top: 0;
}

.renew3_top .format_link:nth-of-type(3n-1):nth-last-of-type(1) {
  margin-right: auto;
}

.renew3_top .format_link:hover {
  transform: scale(1.04);
  text-decoration: none;
  opacity: 1;
}

.renew3_top .format_link_top {
  position: relative;
  text-align: center;
  background: #eef5e8;
  border-radius: 5px 5px 0 0;
  height: 80px;
  overflow: hidden;
}

.renew3_top .format_link_top2 {
  background: #fef5f1;
}

.renew3_top .youtube-card {
  .format_link_top {
    height: 150px;
    padding: 15px 10px;
    background: #fbeaed;

    @include max-width(sm) {
      height: 170px;
    }

    .format_link_memo {
      color: #e3165c;
      border: 1px solid #e3165c;
    }

    .format_link_img {
      width: 100%;
      padding-top: 0;
    }

    .sp {
      display: none;

      @include max-width(sm) {
        display: block;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .format_btn {
    background: #e3165c;
  }
}

.renew3_top .format_link_memo {
  position: absolute;
  display: inline-block;
  font-weight: bold;
  font-size: 10px;
  color: #e95b10;
  background: #ffffff;
  border: 1px solid #e95b10;
  padding: 0 10px;
  margin-right: 5px;
  border-radius: 25px;
  top: 5px;
  left: 5px;
}

.renew3_top .format_link_img {
  display: block;
  width: 90%;
  padding-top: 10px;
  margin: 0 auto;
}

.renew3_top .format_link_bottom {
  background: #eef5e8;
  padding: 10px;
  height: 70px;
}

.renew3_top .format_link_bottom2 {
  background: #fef5f1;
}

.renew3_top .format_link_h3 {
  font-weight: bold;
  font-size: 16px;
  color: #004d40;
}

.renew3_top .format_link_txt {
  font-size: 12px;
}

.renew3_top .format_btn {
  width: 100%;
  padding: 10px;
  border: none;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background: #0f9934;
  border-radius: 0 0 5px 5px;
}

.renew3_top .format_btn:hover {
  opacity: 1;
}

.renew3_top .format_btn2 {
  background: #e95b10;
}

.renew3_top .format_btn3 {
  background: #004d40;
}

/*サービス*/
.renew3_top .service {
  margin-bottom: 50px;
  background: #eef5e8;
  padding: 50px 0;
}

.renew3_top .service_h3 {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}

.renew3_top .service_item {
  margin-bottom: 30px;
}

.renew3_top .service_item_title {
  position: relative;
  font-weight: bold;
  font-size: 16px;
  color: #e95b10;
  margin-bottom: 10px;
  padding-left: 10px;
}

.renew3_top .service_item_title::before {
  position: absolute;
  content: '';
  background: #e95b10;
  width: 5px;
  height: 25px;
  left: 0;
}

.renew3_top .service_img_list {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.renew3_top .service_img_item {
  width: 100px;
  height: auto;
  margin-right: 8px;
}

.renew3_top .formatbtn_list {
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

//ヤギッシュとは
.renew3_top .about-content {
  margin-bottom: 50px;

  &__lead {
    width: 80%;
    margin: 0 auto 30px;
    word-break: break-all;
  }
}

.about-grid {
  display: flex;
  justify-content: space-between;
  gap: 25px;

  // タブレット・スマホ用のレスポンシブ設定
  @include max-width(sm) {
    flex-direction: column;
    align-items: center;
    width: 80%;
    margin: 0 auto;
  }
}

.about-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__image-wrapper {
    width: 100%;
    margin-bottom: 5px;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  &__title {
    color: #0f9934;
    font-size: 1rem;
    font-weight: bold;
    margin: 0 0 5px 0;
    text-align: center;
    letter-spacing: 0.05em;
  }

  &__text {
    line-height: 1.6;
    margin: 0;
    text-align: left; // 説明文は画像に合わせて左寄せ
    width: 100%;
  }
}

//キャリアセンター
.support-banner {
  max-width: 500px;
  margin: 0 auto 50px;
  padding: 0 20px;

  &__link {
    text-decoration: none;
    display: block;
    position: relative;

    // ホバー時の矢印アニメーション
    &:hover {
      .support-banner__arrow-icon {
        transform: translate(5px, -50%) rotate(45deg);
      }

      .support-banner__arrow-circle {
        background-color: #f9f9f9; // 軽く背景色を変える場合
      }
    }
  }

  &__content {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__image-container {
    position: relative;
    width: 100%;
  }

  &__bg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__overlay {
    position: absolute;
    top: 50%;
    left: 40px;
    transform: translateY(-50%);
  }

  &__en {
    display: inline-block;
    color: #0f9934;
    font-family: $font-family-serif;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.2em;
    line-height: 1;
    padding-bottom: 5px;
    background: rgba(255, 255, 255, 0.9);
    padding: 10px;
  }

  &__jp {
    font-size: 12px;
    margin: 5px 0 0 0;
    background: rgba(255, 255, 255, 0.9);
    padding: 5px;
  }

  // 右側の丸い矢印ボタン
  &__arrow-circle {
    position: absolute;
    right: -10px;
    bottom: -10px;
    width: 50px;
    height: 50px;
    background: #fff;
    border: 2px solid #0f9934;
    border-radius: 50%;
    z-index: 2;
    transition: background-color 0.3s ease;
  }

  &__arrow-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 12px;
    border-top: 2px solid #0f9934;
    border-right: 2px solid #0f9934;
    transform: translateY(-50%) rotate(45deg); // 矢印の先端作成
    transition: transform 0.3s ease;

    // 矢印の「棒」部分
    &::before {
      content: '';
      position: absolute;
      top: -1px;
      right: 0;
      width: 25px;
      height: 2px;
      background: #0f9934;
      transform: rotate(-45deg);
      transform-origin: top right;
    }
  }
}

/*お問い合わせ*/
.renew3_top .contact {
  margin-bottom: 50px;
}

.renew3_top .contact_list {
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.renew3_top .contact_link {
  width: calc(50% - 5px);
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.4;
  padding: 10px 0;
  border: 3px solid #0f9934;
  border-radius: 5px;
}

.renew3_top .contact_link:hover {
  background: #c7deb3;
  text-decoration: none;
  opacity: 1;
}

.renew3_top .contact_link span {
  font-size: 14px;
}

/*SP*/
@media screen and (max-width: 640px) {
  /*共通*/
  .renew3_top .renew3_wrapper {
    width: 100%;
  }

  /*フォーマット選択*/
  .renew3_top .format_link {
    width: calc(50% - 10px);
  }

  .renew3_top .format_link:nth-of-type(3) {
    margin-top: 20px;
  }

  .renew3_top .format_link_bottom1 {
    height: 90px;
  }

  .renew3_top .format_link_h3 {
    font-size: 14px;
  }

  .renew3_top .format_btn {
    font-size: 14px;
  }

  /*お問い合わせ*/
  .renew3_top .contact_link {
    width: 100%;
    margin-bottom: 15px;
  }

  .renew3_top .contact_link:last-child {
    margin-bottom: 0;
  }

  .renew3_top .format_link_h3big {
    font-size: 16px;
  }
}

//お知らせ
.renew3_top .news {
  margin-bottom: 20px;
}

.renew3_top .news_text {
  border: 1px solid #0f9934;
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
}

//NEWS
.news-section {
  padding: 50px 0 100px;
  background-color: #ffffff;
  /* デザインにある斜めストライプを再現 */
  background-image: repeating-linear-gradient(
    45deg,
    #f3f9e9,
    #f3f9e9 15px,
    #ffffff 15px,
    #ffffff 30px
  );
}

.news-inner {
  max-width: 960px;
  margin: 0 auto;
}

/* ヘッダー部分 */
.news-header {
  text-align: center;
  margin-bottom: 40px;

  .news-title {
    font-size: 60px;
    font-weight: 900;
    color: #0f9934;
    margin: 0;
    line-height: 1;
    letter-spacing: 0.05em;
    -webkit-text-stroke: 1.5px #0f9934;
    paint-order: stroke fill;
    font-family: 'Arial Black', 'Helvetica Neue', sans-serif;
    text-shadow:
      3px 3px 0 #ffffff,
      6px 6px 0 #0f9934;
  }

  .news-subtitle {
    display: block;
    font-size: 14px;
    margin-top: 5px;
  }
}

/* カードレイアウト */
.news-list {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;

  @include max-width(sm) {
    justify-content: center;
  }
}

.news-card {
  flex: 1;
  min-width: 300px;
  max-width: 440px;

  &:nth-child(2n) {
    position: relative;
    top: 50px;

    @include max-width(sm) {
      top: 0;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px 0;
    margin-bottom: 10px;
  }

  &__content {
    padding: 0 5px;
  }

  &__text {
    line-height: 1.6;
    background: #ffffff;
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 14px 20px;
  }

  /* ボタンエリア */
  &__footer {
    position: relative;
    display: inline-flex;
    align-items: center;
  }
}

.shop-carousel {
  margin: 0 auto;
  background: #f5f5f5;
  padding-bottom: 50px;
  font-family: 'Helvetica Neue', Arial, sans-serif;

  .section-title__group {
    margin-bottom: 0;
  }

  .ribbon-container {
    position: relative;
    text-align: center;
    top: -20px;
  }

  .ribbon-badge {
    display: inline-block;
    background-color: #e95b10;
    color: #ffffff;
    font-weight: bold;
    font-size: 14px;
    padding: 8px 30px;
    position: relative;
    clip-path: polygon(0% 0%, 100% 0%, 92% 50%, 100% 100%, 0% 100%, 8% 50%);
    letter-spacing: 0.05em;
    line-height: 1.5;
    text-align: center;
  }

  .section-title {
    &__en {
      color: #ffffff;
    }
  }

  .carousel-viewport {
    width: 100%;
    overflow: hidden;
    padding: 20px 0;
  }

  .carousel-track {
    display: flex;
    transition: transform 0.5s ease-in-out;
    width: 100%;
  }

  // 共通カードスタイル
  .card-item {
    flex: 0 0 33.33%; // 3枚表示
    padding: 0 10px;
    box-sizing: border-box;

    @include max-width(sm) {
      width: 100%;
    }

    .card-image {
      width: 100%;
      height: auto;
      border-radius: 8px;
      display: block;
    }
  }

  .action-area {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}

//ログイン専用
.login-btn {
  &__btn {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 25px;
    margin: 0 auto;
    width: 180px;
    height: 44px;
    background-color: #d9d9d9;
    /* グレーの背景 */
    border: 2px solid #0f9934;
    /* 緑の枠線 */
    border-radius: 25px;
    color: #0f9934;
    text-decoration: none;
    font-weight: bold;
    font-size: 15px;
    transition: all 0.2s ease;

    //&:hover {
    //    background-color: #e2e2e2;
    //    transform: translateY(-1px);
    //}
  }

  &__button-area {
    display: inline-block;
    position: relative;
    left: calc(50% - 90px);
  }

  /* ログイン限定バッジ */
  &__badge {
    position: absolute;
    width: 80px;
    height: 80px;
    top: -17px;
    right: -40px;
  }
}
</style>

<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
import FloatingButton from '../components/yagiprime/FloatingButton.vue'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'

// const MessageInvoker = {
//     postMessage: function (message) {
//         console.error(`Message received: ${message}`)
//     }
// }
export default {
  props: {
    affId: {
      type: String
    },
    oemId: {
      type: String
    }
  },
  components: {
    'blog-widget': blogWidget,
    'yagi-omikuji': YagiOmikuji,
    Slick,
    'floating-button': FloatingButton
  },
  data: function () {
    return {
      unLoginBanner: '/static/renew3_img/yagish_eprint20241114.png',
      unLoginBannerId: 'top_eprint_bnr',
      unLoginBannerLnk: '',
      oemList: ['kokudo-bl'],
      is_not_midnight: true,
      recentEdit: {
        FormatId: ''
      },
      topflag: '2',
      top_pattern: 'ptn1b',
      isWhat: true,
      isWho: false,
      selectedKind: '',
      selectedHash: '',
      mvBanner: 1,
      noticeInfo: null,
      isSpecial20240508: false,
      slickOptions: {
        centerMode: true,
        // centerPadding: '-20px',
        variableWidth: false,
        accessibility: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 4000,
        asNavFor: '.slider-nav',
        speed: 400
      },
      slickNavOptions: {
        focusOnSelect: true,
        asNavFor: '.slider-for',
        variableWidth: false,
        slidesToShow: 5,
        centerPadding: '20px'
      },
      randomNumber: 0
    }
  },
  methods: {
    // prefetchEprintHelp () {
    //   if (this._eprintPrefetched) return
    //   this._eprintPrefetched = true
    //   import(/* webpackPrefetch: true */ '@/views/pages/EprintHelp')
    // },
    searchHash: function (_hash) {
      this.selectedHash = _hash
    },
    searchKind: function (_kind) {
      this.selectedKind = _kind
    },
    getLink: function (f_id) {
      if (f_id == 'line_yagibot') {
        return process.env.VUE_APP_YAGIBOT_URL // 'https://lin.ee/lQ9AmgT' // https://lin.ee/FniFZ1i
      } else if (f_id == 'y') {
        return 'https://portal.yagish.jp/know-how/mid-career_how-to-write/#index2'
      } else {
        return '/format/' + f_id + '?frm=' + this.top_pattern
      }
    },
    getTarget: function (f_id) {
      if (f_id == 'line_yagibot') {
        return '_blank'
      } else {
        return ''
      }
    },
    reload: function () {
      location.reload(true)
    },
    recentEditClass: function (format) {
      if (!this.recentEdit) return
      if (this.recentEdit.FormatId === format.id) {
        return {
          'current-edit': true
        }
      }
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    updateRecentEdit: function (data) {
      if (data) {
        this.recentEdit = data
      }
    },
    toggleButton: function () {
      if (this.isWhat) {
        this.isWhat = false
        this.isWho = true
      } else {
        this.isWhat = true
        this.isWho = false
      }
      this.selectedKind = ''
      this.selectedHash = ''
    },
    getSelectedHash: function (classname, val) {
      if (val == this.selectedHash) {
        return classname + ' select'
      } else {
        return classname
      }
    },
    getSelectedKind: function (classname, val) {
      if (val == this.selectedKind) {
        return classname + ' select'
      } else {
        return classname
      }
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    currentOemUniqueId() {
      const { oemUniqueId } = this.$route.params || {}
      return oemUniqueId || this.$oemContext.currentOemUniqueId
    },
    schoolName: function () {
      return this.$oemContext.getName()
    },
    supportBanners() {
      return this.$oemContext.getSupportBanners()
    },
    newsItems() {
      return this.$oemContext.getNews()
    },
    shopItems() {
      return this.$oemContext.getShop()
    },
    forSearchHashs: function () {
      const _rtVal = []
      if (this.selectedHash) {
        for (const obj of this.$site.rirekishoFormatsIndex) {
          for (const _hash of obj.hashs) {
            if (_hash == this.selectedHash) {
              _rtVal.push(obj)
            }
          }
        }
        return _rtVal
      } else {
        return this.$site.rirekishoFormatsIndex
      }
    }
  },
  created: function () {
    // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
    this.loadRecentEdit()
    const now = new Date()
    if (now.getHours() >= 0 && now.getHours() < 6) {
      this.is_not_midnight = false
    }

    if (Math.floor(Math.random() * 2) == 0) {
      this.topflag = '1'
      this.top_pattern = 'ptn1a'
    } else {
      this.topflag = '2'
      this.top_pattern = 'ptn1b'
    }
    this.topflag = '4'
    this.top_pattern = 'ptn2b_list'
    if (this.$site.appFlag == 'b') {
      this.topflag = '3'
      this.top_pattern = 'app'
    }
    this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$on('reload', this.reload)

    const nowdate = new Date()
    const date1 = new Date('2024/05/09 00:00:00')
    const date2 = new Date('2024/05/12 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isSpecial20240508 = true
    } else {
      this.isSpecial20240508 = false
    }
    if (Math.floor(Math.random() * 2) == 0 && false) {
      this.unLoginBanner = '/static/renew3_img/yagiprime_superegent20241114.png'
      this.unLoginBannerId = 'top_superagent_bnr'
      this.unLoginBannerLnk = '/yagiprime_superagent'
    }

    const app = this

    const formData = new FormData()
    this.$axios
      .post(this.$varuna.endPoints.getNoticeinformation, formData, {
        timeout: 60000
      })
      .then(function (response) {
        console.error(response.data)
        for (const _key in response.data.notice_list) {
          app.noticeInfo = response.data.notice_list[_key]
          break
        }
      })
      .catch(function (error) {})
      .finally(function () {})

    const { oemUniqueId } = this.$route.params || {}
    if (oemUniqueId) {
      this.$oemContext.setOem(oemUniqueId)
    }
  },
  destroyed: function () {
    this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$off('reload', this.reload)
  },
  beforeMount: function () {
    if (Math.floor(Math.random() * 2) == 0) {
      this.randomNumber = 0
    } else {
      this.randomNumber = 1
    }
    console.error(this.affId)
    if (this.affId) {
      console.error(this.affId)
      this.$cookies.config(60 * 60 * 24, '')
      this.$cookies.set(
        '_YAGISH_AFFILIATE_ID',
        this.affId,
        null,
        null,
        'yagish.jp'
      )
      this.$cookies.set(
        '_YAGISH_AFFILIATE_ID',
        this.affId,
        null,
        null,
        'localhost'
      )
    }
    if (this.oemList.indexOf(this.oemId) >= 0) {
      console.error(this.oemId)
      this.$cookies.config(60 * 60 * 24, '')
      this.$cookies.set('_YAGISH_OEM_ID', this.oemId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_OEM_ID', this.oemId, null, null, 'localhost')
      this.$cookies.set(
        '_YAGISH_AFFILIATE_ID',
        this.oemId,
        null,
        null,
        'yagish.jp'
      )
      this.$cookies.set(
        '_YAGISH_AFFILIATE_ID',
        this.oemId,
        null,
        null,
        'localhost'
      )
    }
  }
}
</script>
